export default "__VITE_ASSET__CW$Ddz30__"